@if (isVisible) {
  <div class="file-upload" [formGroup]="formGroup">
    <form-control-label [id]="controlId" [question]="componentData" [flow]="flowComponent"></form-control-label>
    <div class="grid-x">
      <div class="cell">
        File should consist of an Excel file of API numbers in Column "A" starting in Row 1, or Row 2 with a column header.
      </div>
      <div class="cell large-12 medium-12 small-12">
        <div class="checkbox">
          <label>
            <input class="show-for-sr" type="checkbox" [attr.id]="headerKey" formControlName="hasHeaders" (ngModelChange)="setHasHeaders($event)" />
            <label aria-hidden="true" [attr.for]="headerKey" class="inline">
              <span class="checkbox-box"><span class="checkbox-check">&#x2714;</span></span>
              <span class="control-label-text padding-left">Uploaded file contains column headings.</span>
            </label>
          </label>
        </div>
      </div>
    </div>
    @if (!disable) {
      <upload-view-files [uniqueId]="componentData.key" [componentLabel]="''" [isPadded]="false" (newFilesList)="parseFile($event)" [showFileList]="false" [allowDeletion]="!disable"></upload-view-files>
    } @else {
      <div class="drop-area grid-x">
        <span class="italic">
          {{disabledMessage}}
        </span>
      </div>
    }
    @if (hasFileListing) {
      <div class="file-list padding-all-small">
        <h3 class="minor margin-bottom h6">Uploaded Files</h3>
        @for (file of uploadedFiles; track file) {
          <div class="flex">
            <uploaded-file [allowFileDeletion]="!uploadComplete && !disable" [file]="file" (fileDeleted)="deleteFile($event)"></uploaded-file>
          </div>
        }
      </div>
    }
    <text-loader [run]="!fileRead && hasFileListing" [text]="'Reading File'" [interval]="1000" [tickType]="'.'"></text-loader>
    @if (fileRead) {
      <div class="grid-x margin-top">
        <div class="cell small-6 medium-6 large-6">
          <span class="bold">Parsed APIs:</span><help-text [helpText]="'Parsed APIs will be automatically selected in the selection grid'"></help-text>
        </div>
        <div class="cell small-6 medium-6 large-6 text-align-right">
          <button class="button" (click)="export()">Export Parser Results</button>
        </div>
        <div class="cell margin-bottom margin-top">
          <ag-grid-angular class="data-grid " [gridOptions]="parsedGridOptions" [rowData]="parsedData" [excelStyles]="excelStyles" aria-label="Bulk Well Transfer Parser"></ag-grid-angular>
        </div>
        <div class="cell bold">
          Errors:
        </div>
        @if (errorData && errorData.length > 0) {
          <div class="cell">
            <ag-grid-angular class="data-grid " [gridOptions]="errorGridOptions" [rowData]="errorData" aria-label="Bulk Well Transfer Parser"></ag-grid-angular>
          </div>
        } @else {
          <div class="cell bold">
            File contains no errors.
          </div>
        }
      </div>
    }
    <a style="display:none;" #downloadLink></a>
  </div>
}




